import {
  APP_ID,
  enableProdMode,
  ErrorHandler,
  importProvidersFrom,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';

import { environment } from './environments/environment';
import { CanDeactivateGuard } from '@guards/can-deactivate-guard/can-deactivate-guard';
import { RequestCache } from '@services/request-cache/request-cache.service';
import { TRANSLATIONS, createTranslateLoader } from '@modules/i18n/1.0';
import { GlobalErrorHandlerService } from '@services/global-error-handler/1.0/global-error-handler.service';
import {
  MAT_FORM_FIELD_DEFAULT_OPTIONS,
  MatFormFieldDefaultOptions,
} from '@angular/material/form-field';
import {
  MAT_COLOR_FORMATS,
  NGX_MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
} from '@nng-components/angular-material-color-picker';
import { provideHttpClient, withInterceptorsFromDi, HttpClient } from '@angular/common/http';
import { AppRoutingModule } from './app/app-routing.module';
import { AuthModule } from '@auth0/auth0-angular';
import { SharedModule } from '@app/shared.module';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { bootstrapApplication } from '@angular/platform-browser';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';
import { NgxPermissionsModule } from 'ngx-permissions';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { AppComponent } from './app/app.component';

const appearance: MatFormFieldDefaultOptions = {
  appearance: 'outline',
};

function initializeIssApi() {
  (window as any)['issApiUrl'] = environment.issApi || '';
  (window as any)['issApiKey'] = environment.issApiKey || '';
}

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideAppInitializer(initializeIssApi),
    importProvidersFrom(
      AppRoutingModule,
      AuthModule.forRoot({
        domain: environment.authConfig.domain,
        clientId: environment.authConfig.client_id,
        authorizationParams: {
          audience: environment.authConfig.audience,
          redirect_uri: environment.authConfig.redirect_uri,
          active_tenant_identifier: localStorage.getItem('active_tenant_identifier'),
        },
      }),
      SharedModule,
      CommonModule,
      FormsModule,
      [BrowserAnimationsModule],
      [NoopAnimationsModule],
      NgxMatColorPickerModule,
      NgxPermissionsModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient, PLATFORM_ID, TRANSLATIONS],
        },
      }),
    ),
    CanDeactivateGuard,
    RequestCache,
    { provide: TRANSLATIONS, useValue: 'Not SSR' },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
    { provide: APP_ID, useValue: 'txp-root' },
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: appearance },
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    provideHttpClient(withInterceptorsFromDi()),
  ],
}).catch((err) => console.error(err));
